import {IS_DEBUG} from "../constants/debug";


export const logger = (variable) => {
  if (IS_DEBUG === true) {
    console.log(variable);
  }
};